<template>
  <div ref="chart" :id="id"></div>
</template>

<script>
import Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more'
import HCSoldGauge from 'highcharts/modules/solid-gauge';
import HCAnnotations from 'highcharts/modules/annotations';
import HCHistogram from 'highcharts/modules/histogram-bellcurve';

export default {
  props: {
    id: { type: String, required: true },
    title: { type: String, required: false },
    type: { type: String, required: false, default: 'column' },
    graphProps: { type: Object, required: true },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    More(Highcharts)
    HCSoldGauge(Highcharts)
    HCAnnotations(Highcharts);
    HCHistogram(Highcharts);
    this.renderChart(false);
  },
  methods: {
    areGraphPropsEqual(newGraphProps, oldGraphProps) {
      try {
        return JSON.stringify(newGraphProps) === JSON.stringify(oldGraphProps);
      } catch (error) {
        return false;
      }
    },
    
    renderChart(animation) {
      if (this.chart) {
        this.chart.destroy();
      }
      const props = this.graphProps.props || {};
      this.chart = Highcharts.chart(this.$refs.chart, {
        chart: {
          type: this.type
        },
        plotOptions: {
          series: {
            animation
          }
        },
        yAxis: {
          ...this.graphProps.yAxis,
          min: this.graphProps.yAxis.min || 0,
          max: this.graphProps.yAxis.max || 100
        },
        annotations: props.annotations || [],
        ...this.graphProps
      });
    }
  },
  watch: {
    graphProps: {
      deep: true,
      handler(newGraphProps, oldGraphProps) {
        if (this.areGraphPropsEqual(newGraphProps, oldGraphProps)) {
          return;
        }
        this.renderChart(true)
      }
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
/* Estilos opcionais do componente */
</style>
